/**
 * Plugin operates the main info modal added to the APP root element.
 * Modal can be shown in different colors depending on the type provided.
 *
 * Usage:
 *   - from component
 *      this.$infoModal.show(params);
 *   - from actions or other resources that do not have an access to the vue object
 *      - pass in the 'this.$infoModal' as parameter
 *      - then call 'show' on that parameter
 *
 * @param title Optional. Title for the modal. If omitted then the type is used as title.
 * @param message Message for the modal content box.
 * @param type Optional. Type of the modal. Possible options are 'ERROR', 'INFO'. Default 'INFO'.
 * @param confirmButtonText Optional. Text for the callback button. Default 'Confirm'.
 * @param confirmCallback Optional. Method to be executed from the modal.
 */

import InfoModalComponent from './InfoModalComponent';

const InfoModal = {
  // eslint-disable-next-line no-unused-vars
  install(Vue, options) {
    Vue.component('info-modal-sb', InfoModalComponent);
    Vue.prototype.$infoModalEventBus = new Vue();
    Vue.prototype.$infoModal = {
      show(params) {
        Vue.prototype.$infoModalEventBus.$emit('show', params);
      },
    };
  },
};

export default InfoModal;
